<template>
  <div>
    <Toast position="bottom-left" />
    <Breadcrumb class="p-mb-3" :home="home" :model="breadcrumbItems" />

    <DataTable
      :value="listItems"
      :filters="filters"
      :loading="loading"
      selectionMode="multiple"
      :selection.sync="selectedItems"
      data-key="id"
      :paginator="true"
      :lazy="true"
      :totalRecords="totalRecords"
      @page="onPage"
      @sort="onSort"
      :rows="rows"
      @row-click="onRowClick"
      :first="firstRecordIndex"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
      currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords}"
    >
      <template #empty>آیتمی یافت نشد</template>

      <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>

      <Column field="name" header="نام" key="name" :sortable="true">
        <template #filter>
          <InputText
            type="text"
            v-model="filters['name']"
            @keypress.enter="filterBy"
            class="p-column-filter"
          />
        </template>
      </Column>

      <Column field="relatedEntity" header="برای" key="relatedEntity">
        <template #body="slotProps">
          <a target="_blank" :href="getCommentLink(slotProps.data)">
            {{ slotProps.data.relatedEntity }}
          </a>
        </template>
      </Column>

      <Column field="isActive" header="فعال" key="isActive" :sortable="true">
      </Column>

      <Column
        field="parentCommentId"
        header="پاسخ؟"
        key="parentCommentId"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="!slotProps.data.parentCommentId">
            <span v-if="slotProps.data.replyedByAdmin"> پاسخ داده شد </span>
          </span>
        </template>
      </Column>

      <Column
        headerStyle="width: 300px"
        field="message"
        header="پیام"
        key="message"
        :sortable="true"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['message']"
            @keypress.enter="filterBy"
            class="p-column-filter"
          />
        </template>
        <template #body="slotProps">
          <span :title="slotProps.data.message">
            {{ slotProps.data.message.substring(0, 80) }}
          </span>
        </template>
      </Column>

      <Column header="مدیریت">
        <template #body="slotProps">
          <router-link
            tag="a"
            class="p-button-rounded p-button-success p-ml-2 p-button p-component p-button-icon-only"
            target="_blank"
            class-active="active"
            :to="getEditPageUrl(slotProps.data)"
            exact
          >
            <span class="pi pi-pencil p-button-icon"></span>
          </router-link>
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-warning"
            @click="confirmDeleteItem(slotProps.data)"
          />

          <Button
            icon="pi pi-reply"
            class="p-button-rounded p-button-danger"
            @click="showReplyForm(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>

    <Dialog
      :visible.sync="deleteItemsDialog"
      :style="{ width: '450px' }"
      header="تایید حذف"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>آیا از حذف موارد انتخاب شده مطمئن هستید؟</span>
      </div>
      <template #footer>
        <Button
          label="خیر"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteItemsDialog = false"
        />
        <Button
          label="بله"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteSelectedItems"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="deleteItemDialog"
      :style="{ width: '450px' }"
      header="تایید حذف"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="item">آیا از حذف مورد انتخاب شده مطمئن هستید؟</span>
      </div>
      <template #footer>
        <Button
          label="خیر"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteItemDialog = false"
        />
        <Button
          label="بله"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteItem"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="replyDialog"
      v-if="item"
      :style="{ width: '450px' }"
      header="پاسخ سریع کامنت"
      :modal="true"
    >
      <div class="p-fluid">
        <div class="p-field">
          <strong>متن پیام کاربر</strong>
          <p>
            {{ item.message }}
          </p>
        </div>

        <div class="p-field" v-if="item.replys">
          <strong>پاسخ شما</strong>
          <p v-for="reply of item.replys" :key="reply">
            {{ reply }}
          </p>
          <hr />
        </div>

        <div class="p-field">
          <Textarea
            v-model="item.reply"
            placeholder="متن مورد نظر برای پاسخ"
            :autoResize="true"
            rows="5"
            cols="30"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="لغو"
          icon="pi pi-times"
          class="p-button-text"
          @click="replyDialog = false"
        />
        <Button
          label="ذخیره"
          icon="pi pi-check"
          class="p-button-text"
          @click="replyComment"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { getters } from "./../../store.js";
import CrudService from "@/service/CrudService";
import CommentService from "@/service/CommentService";
import helper from "@/helper";

export default {
  data() {
    return {
      moduleName: "Comment",
      moduleLabel: "نظرات",
      home: { icon: "pi pi-home", to: "/" },
      breadcrumbItems: [],
      filters: {},
      loading: true,
      totalRecords: 0,
      pageNumber: 0,
      sortField: null,
      sortOrder: null,
      rows: 25,
      listItems: null,
      selectedItems: null,
      item: null,
      deleteItemsDialog: false,
      deleteItemDialog: false,
      replyDialog: false,
    };
  },
  methods: {
    getCommentLink(data) {
      switch (data.relatedEntity) {
        case "Cambridge":
          return `https://nextapi.logonomy.ir/CambridgeBook-IELTS/Reading/${data.relatedEntityId}`;
        case "Tpo":
          return `https://nextapi.logonomy.ir/Tpos/Reading/${data.relatedEntityId}`;
        case "Gre":
          return `https://nextapi.logonomy.ir/Gre/Writing/Issue/${data.relatedEntityId}`;
        case "Article":
          return `https://nextapi.logonomy.ir/Article/${data.relatedEntityId}`;
        default:
          return `https://nextapi.logonomy.ir/CambridgeBook-IELTS/Reading/${data.relatedEntityId}`;
          break;
      }
    },
    setBreadcrumb() {
      this.moduleLabel = this.modules.filter(
        (x) => x.name == this.moduleName
      )[0].label;
      this.breadcrumbItems = [];
      this.breadcrumbItems.push({ label: this.moduleLabel });
    },
    onRowClick() {
      const selectedItems = this.selectedItems;
      setTimeout(() => {
        this.selectedItems = selectedItems;
      }, 10);
    },
    confirmDeleteSelected() {
      this.deleteItemsDialog = true;
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    async showReplyForm(item) {
      const itemDetails = await this.commentService.details(item.id);
      this.item = itemDetails;

      this.replyDialog = true;
    },

    async replyComment() {
      const result = await this.commentService.reply({
        name: "شایسته",
        email: "support@shayesteh.ir",
        message: this.item.reply,
        parentCommentId: this.item.id,
      });

      this.replyDialog = false;
      this.item = null;

      await this.fetchItems();
    },

    async deleteSelectedItems() {
      const selected_ids = this.selectedItems.map((item) => item.id);

      const success = await this.crudService.deleteItems(selected_ids);
      this.deleteItemsDialog = false;

      helper.toastDeleteResult(success, this.$toast);

      this.pageNumber = 0;
      await this.fetchItems();

      this.selectedItems = null;
    },
    async deleteItem() {
      const success = await this.crudService.deleteItem(this.item.id);
      this.deleteItemDialog = false;

      helper.toastDeleteResult(success, this.$toast);

      if (success) {
        //delete row cliet side
        this.listItems = this.listItems.filter(
          (item) => item.id !== this.item.id
        );
      }

      this.item = null;
    },

    getEditPageUrl(data) {
      return this.moduleName ? `/Edit/${this.moduleName}/${data.id}` : "";
    },

    async filterBy() {
      this.pageNumber = 0;
      await this.fetchItems();
    },
    async onSort(event) {
      this.pageNumber = 0;
      this.sortField = event.sortField;
      this.sortOrder = event.sortOrder;
      await this.fetchItems();
    },
    async onPage(event) {
      this.pageNumber = event.page;
      await this.fetchItems();
    },
    async fetchItems() {
      this.loading = true;
      try {
        const list = await this.commentService.getList(
          this.rows,
          this.pageNumber,
          this.filtersString,
          this.sortField,
          this.sortOrder
        );

        this.totalRecords = list.totalCount;
        this.listItems = list.items;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: `اشکال در بارگذاری اطلاعات!`,
          detail: error,
        });
      }
      this.loading = false;
    },
  },

  crudService: null,
  commentService: null,
  computed: {
    ...getters,
    firstRecordIndex: function () {
      return this.pageNumber * this.rows;
    },
    filtersString: function () {
      let filters = [];
      let filtersObj = JSON.parse(JSON.stringify(this.filters));
      for (const key in filtersObj) {
        if (filtersObj.hasOwnProperty(key)) {
          filters.push(`${key}=${filtersObj[key]}`);
        }
      }
      return filters.join(";");
    },
  },

  async mounted() {
    this.crudService = new CrudService(this.moduleName, this);
    this.commentService = new CommentService(this);
    this.setBreadcrumb();
    await this.fetchItems();
  },
};
</script>